/**
 * @module common/DualAxis/fields/AxisMetricMultiField
 * @description 折线双轴 · 指标多选
 */

import React from 'react';
import { useIntl } from 'umi';
import FilterSelect from '@/pages/dashboard/components/FilterSelect';

interface IAxisMetricMultiFieldProps {
  value: string[];
  options: Record<string, unknown>[];
  onChange: (keys: string[]) => void;
  className?: string;
  selectClassName?: string;
  overlayClassName?: string;
}

const AxisMetricMultiField: React.FC<IAxisMetricMultiFieldProps> = ({
  value,
  options,
  onChange,
  className = '',
  selectClassName = 'dbl-dual-axis-field__metric-multi-select',
  overlayClassName = 'dbl-dual-axis-field__metric-multi-overlay',
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className={`dbl-chart-setting-row ${className}`}>
      <div className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_primary_metic' })}
      </div>
      <FilterSelect
          className={selectClassName}
          overlayClassName={overlayClassName}
          name={formatMessage({ id: 'dbl_chart_primary_metic' })}
          tooltip=""
          placeholder={formatMessage({ id: 'dbl_chart_select_placeholder' })}
          clickClose={false}
          value={value}
          options={options}
          listWidth={210}
          listHeight={180}
          onChange={onChange}
        />
    </div>
  );
};

export default React.memo(AxisMetricMultiField);
